import { IHaveActiveDailyRents } from 'shared/types/features';
import { TApplicationState } from 'shared/types/redux';

export const selectHaveActiveDailyRents = (state: TApplicationState): IHaveActiveDailyRents | null => {
  return state.haveActiveDailyRents;
};
